<template>
<div> 
  <div v-if="is_super_admin">
  <div style="margin-block: 16px; margin-left: 16px;">
          <el-button type="primary" icon="el-icon-plus"
          size="mini" plain
          @click="add_department_top"
          >新增部门</el-button>
        </div>

  <el-table
    :data="l_department_tree_data"
    style="width: 100%;margin-bottom: 20px;"
    row-key="department_id"
    default-expand-all
    highlight-current-row
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}">

    <el-table-column
      prop="department_name"
      label="部门名称"
      >
    </el-table-column>

    <el-table-column
      prop="department_detail"
      label="状态"
      align="center"
      >
      <template slot-scope="scope"> 

        <el-tag type="success" v-if="scope.row.department_detail == '正常'">
          <span> 正常 </span>
        </el-tag>

        <el-tag type="danger" v-if="scope.row.department_detail == '停用'" >
          <span> 停用 </span>
        </el-tag>
       
      </template>
    </el-table-column>

    <el-table-column
      align="center"
      prop="user_name"
      label="负责人">
    </el-table-column>

    <el-table-column
      align="center"
      prop="phone_num"
      label="电话">
    </el-table-column>

    <el-table-column
      align="center"
      prop="email"
      label="邮箱">
    </el-table-column>

    <el-table-column label="操作" align="center" fixed="right" width="230">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            @click="department_add(scope.$index, scope.row)">新增</el-button>
          <el-button
            size="mini"
            @click="department_edit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="department_remove(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>

  </el-table>

  <!-- 新增部门 -->
  <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false">
    <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
        <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
        <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
    </div>

    <el-form :model="d_dialog_data" ref="d_dialog_data" label-width="100px" @class="demo-d_dialog_data">
      <el-form-item label="所属部门名称" prop="parent_name">
        <el-input v-model="d_dialog_data.parent_name" :disabled="b_department_name_disabled"></el-input>
      </el-form-item>

      <el-form-item label="新建部门名称" prop="department_name">
        <el-input v-model="d_dialog_data.department_name"></el-input>
      </el-form-item>

      <el-form-item label="部门状态" prop="department_detail">
        <el-select v-model="d_dialog_data.department_detail">
          <el-option label="正常" value="正常"></el-option>
          <el-option label="停用" value="停用"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="负责人" prop="user_id">

        <el-select v-if="d_dialog_data.user_id == 0" v-model="d_dialog_data.user_id">
          <el-option
            v-for="item in l_all_user_name"
            :key="item.id"
            :value="item.id"
            :label="item.username"
          > 
          </el-option>
        </el-select>

        <el-select v-else v-model="d_dialog_data.user_id" @change="user_form_change(d_dialog_data)">
          <el-option
            v-for="item in l_all_user_name"
            :key="item.id"
            :value="item.id"
            :label="item.username"
          > 
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="电话" prop="phone_num">
        <el-input v-model="d_dialog_data.phone_num" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="邮箱" prop="email">
        <el-input v-model="d_dialog_data.email" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit_form()">{{ s_btn_name }}</el-button>
        <el-button @click="cancel_func">取消</el-button> 
       </el-form-item>
    </el-form>
  </el-dialog>

  </div>

  <div v-else>
    <div style="text-align: center;">
      <div style="margin-top: 0px;">
        <img src="../../assets/permission_denied.png">
        <div style="margin-top: 20px;">
          <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
        </div>
      </div>
    </div>
  </div>

</div>


</template>
<script>
  export default {
    name: 'department_system',
    data() {
      return {
        
        // 弹窗名称
        s_dialog_name: '',
        // 是否显示添加部门的弹窗
        b_show_dialog: false,
        // 是否显示全屏
        b_show_fullscreen: false,
        
        l_department_tree_data: [],

        l_department_data: [],

        // d_add_data: {
        //   parent_id: '',
        //   parent_name: '',
        //   department_name: '',
        //   department_id: '',
          
        //   department_detail: '',
        //   user_name: '',
        //   phone_num: '',
        //   email: '',
        //   user_id: 0,
        // },

        d_dialog_data: {},
        
        l_all_user_name: [],

        s_btn_name: '',

        b_department_name_disabled: false,

        b_dialog_type: 1,

        is_super_admin: false,
      }
    },

    mounted() {
      // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
      let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
      if (isSuperAdmin == "false") {
        this.is_super_admin = false
        return
      } else {
        this.is_super_admin = true
      }

      var _this = this
      var d_user_data = {"is_business": 1}

      _this.$axios.get('/api/users/', {params: d_user_data}).then(
        function(res){
        _this.l_all_user_name = res.data
        console.log(res.data)
        }
      )

      // 刷新部门数据并转换为树结构
      this.ref_department_data()
    },

    methods: {
      // 刷新部门数据并转换为树结构
      async ref_department_data(){
        
        let res = await this.$axios.get('/api/department/')
        this.l_department_data = res.data
        this.l_department_tree_data = this.toTree(this.l_department_data, 'department_id', 'parent_id');
        
      },

      // 转换数据为树形结构
      toTree(objects, keyName, parentKeyName) {
 
        if (!keyName) {
          throw "keyName argument is required";
        }

        if (!parentKeyName) {
          throw "parentKeyName argument is required";
        }

        // 列表项字典 将数组变成以objectId分组的对象，类似于{Vvwkeujpo:{},Rohdsfdofj:{}}
        var map = {};
        objects.forEach(x => (map[x[keyName]] = Object.assign({}, x)));
        
        // 已添加到父项的键
        var pushed = {};

        // 遍历列表项，将子项添加到父项的 children 数组
        for (const key in map) {
          if (map.hasOwnProperty(key)) {// 这样就可以过滤掉原型链上的可枚举属性了
            const x = map[key];
            if (x && x[keyName] && x[parentKeyName]) {
              var parent = map[x[parentKeyName]];
              if (parent) {
                if (!parent.children) {
                  parent.children = [];
                }
                parent.children.push(x);
                pushed[x[keyName]] = true;
                }
              }
            }
          }
 
        // 排除已添加到父项的项得到树
        var tree = [];
          for (const key in map) {
            if (map.hasOwnProperty(key)) {
                const x = map[key];
                if (!pushed[x[keyName]]) {
                tree.push(x);
              }
            }
          }
        return tree;
      },

      // 取消
      cancel_func(){
        this.b_show_dialog = false
      },

      // 编辑部门
      department_edit(index, row) {
        this.s_dialog_name = '编辑部门';
        this.s_btn_name = '保存';
        this.b_show_dialog = true;
        this.d_dialog_data = row;
        this.b_dialog_type = 2;
        this.b_department_name_disabled = true;
        // 获取父节点名称
        this.d_dialog_data.parent_name = this.get_parent_name(row.parent_id)
      },

      // 获取父节点名称
      get_parent_name(){
        var _this = this
        var s_parent_name = ''
        this.l_department_data.forEach(function(item, index){
          if(item.department_id == _this.d_dialog_data.parent_id){
            s_parent_name = item.department_name
          }
        })
        return s_parent_name
      },
      
      // 删除部门
      department_remove(index, row){
        var _this = this
        this.$confirm('此操作将永久删除该部门,以及该部门下的所有子部门, 是否继续?', '删除部门警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          _this.$axios.delete('/api/department/' + row.department_id + '/').then(
            function(res){
              _this.$message({
                type: 'success',
                message: '删除成功!'
              });
              _this.ref_department_data()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },

      // 新增部门
      department_add(index, row){
        this.d_dialog_data = {};
        this.s_dialog_name = '新增部门';
        this.s_btn_name = '新建部门';
        this.b_dialog_type = 1;
        this.b_department_name_disabled = true;
        this.$set(this.d_dialog_data, 'parent_id', row.department_id)
        this.$set(this.d_dialog_data, 'parent_name', row.department_name)
        // this.$set(this.d_dialog_data, 'department_id', row.department_id)
        this.b_show_dialog = true;
        
      },

      // 用户表单变动绑定事件
      async user_form_change(d_data){
        let url = '/api/users/' + d_data.user_id + '/'
        var _this = this;
        await this.$axios.get(url).then(res => {
          _this.$set(this.d_dialog_data, 'email', res.data.email)
          _this.$set(this.d_dialog_data, 'phone_num', res.data.phone_num)
          return
        }).catch(err => {
          console.log(err)
        })
      },

      // 提交表单
      async submit_form(){
        if (this.b_dialog_type == 1) {
          let parent_id = this.d_dialog_data.parent_id
          // 计算数形结构子节点id
          let department_num = this.l_department_data.filter(item => item.parent_id == parent_id).length
          let department_id = String(parent_id) + String(department_num + 1)
          this.$set(this.d_dialog_data, 'department_id', department_id)
        }
        this.save_department_info_submit()
        
      },

      // 保存部门信息/提交
      async save_department_info_submit(){
        if (this.b_dialog_type === 1){
          let s_url = '/api/department/'
          let d_data = this.d_dialog_data
          let res = await this.$axios.post(s_url, d_data)
          this.request_waring(res)
          this.ref_department_data()
        }else{
          let s_url = '/api/department/' + this.d_dialog_data.department_id + '/'
          console.log(s_url)
          let d_data = this.d_dialog_data
          let res = await this.$axios.put(s_url, d_data)
          this.request_waring(res)
          this.ref_department_data()
        }

      },

      // 请求警告
      request_waring(res){
        if (res.status === 201 || res.status === 200){
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.b_show_dialog = false
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
      },

      // 新增部门
      add_department_top(){
        this.d_dialog_data = {};
        this.s_dialog_name = '新增部门';
        this.s_btn_name = '新建部门';
        this.b_dialog_type = 1;
        this.b_department_name_disabled = true;
        this.$set(this.d_dialog_data, 'parent_id', 0)
        this.$set(this.d_dialog_data, 'parent_name', '顶级部门')
        this.b_show_dialog = true;
      },
      




    },
  }
</script>